import script from "./Committee.vue?vue&type=script&setup=true&lang=js"
export * from "./Committee.vue?vue&type=script&setup=true&lang=js"

import "./Committee.vue?vue&type=style&index=0&id=fafbb1d8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fafbb1d8"]])

export default __exports__